import { faker } from '@faker-js/faker';

import type { DepartmentDetails, IDN } from '~/api/types';
import { DATE_FORMAT_VALUES } from '~/utils/dateFormats';

import { AddressFactory } from './address';
import { alertSettingsFactory } from './alertSettings';
import { sanitizeCompanyName } from '../../utils';

export const departmentDetailsFactory = ({
  idns,
  overrides,
}: {
  idns: IDN[];
  overrides?: Partial<DepartmentDetails>;
}): DepartmentDetails => {
  const idn = faker.helpers.arrayElement(idns);

  return {
    id: faker.string.numeric(6),
    name: sanitizeCompanyName(),
    careTeamId: faker.string.numeric(6),
    idn,
    address: AddressFactory(),
    phone: faker.phone.number({ style: 'international' }),
    dateFormat: faker.helpers.arrayElement(DATE_FORMAT_VALUES),
    alertsSettings: alertSettingsFactory({}),
    admins: faker.helpers.multiple(() => faker.person.fullName(), {
      count: {
        min: 0,
        max: 5,
      },
    }),
    archivedAt: faker.datatype.boolean()
      ? faker.date.past().toISOString()
      : undefined,
    ...overrides,
  } satisfies DepartmentDetails;
};
